<!--TODO: No Title?-->

<mat-dialog-content>
    <ng-container *ngIf="isLoaded; else loading">
        <tcm-viewer *ngIf="hasTcm; else nativeAttachments" [canEdit]="!readOnly" [docType]="docType" [entityId]="entityId" [entityType]="entityType" [tcmEntity]="tcmEntity">
        </tcm-viewer>
    </ng-container>
</mat-dialog-content>

<mat-dialog-actions *ngIf="hasTcm" fxLayoutAlign="end">
    <button mat-button color="primary" (click)="close()" telemetry="Submission-AttachmentClose">
        Close
    </button>
</mat-dialog-actions>

<ng-template #loading>
    <busy-indicator></busy-indicator>
</ng-template>

<ng-template #nativeAttachments>
    <attachment-viewer fxLayout="column" [docType]="docType" [entityId]="entityId" [entityType]="entityType" [isAdd]="isAdd" [localAttachments]="attachments" [canEdit]="!readOnly">
    </attachment-viewer>
</ng-template>
